import React, { useState } from 'react';
import { SxProps, Theme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import If from '@components/If';
import useBranches from '@core/hooks/useBranches';
import { BranchModel } from '@core/types';

interface BranchsDropdownProps {
  handleSelectedBranchChange: (branch?: BranchModel) => void;
  initialValue?: number;
  hidePlaceholder?: boolean;
  sx?: SxProps<Theme>;
}

const BranchsDropdown: React.FC<BranchsDropdownProps> = ({
  handleSelectedBranchChange,
  initialValue,
  hidePlaceholder = false,
  sx,
}) => {
  const [selectedBranchId, setSelectedBranchId] = useState<number>(initialValue || -1);
  const { branches, isLoading } = useBranches();

  const handleBranchSelection = (e: SelectChangeEvent<number>) => {
    const branchId = Number(e.target.value);

    if (isNaN(branchId)) return;

    setSelectedBranchId(branchId);

    const branchModel = branches.find((s) => s.id === branchId);

    handleSelectedBranchChange(branchModel);
  };

  const itemsPlaceholder = isLoading
    ? 'Cargando sucursales...'
    : branches.length === 0
    ? 'Sin sucursales'
    : 'Selecciona una sucursal';

  return (
    <Select
      displayEmpty
      inputProps={{ 'aria-label': 'Selecciona una sucursal' }}
      value={selectedBranchId}
      onChange={handleBranchSelection}
      sx={sx}
    >
      <If condition={!hidePlaceholder}>
        <MenuItem value={-1}>{itemsPlaceholder}</MenuItem>
      </If>
      {branches.map((branch) => (
        <MenuItem key={branch.id + (branch.name || '')} value={branch.id}>
          {branch.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default BranchsDropdown;
